<template>
  <v-container>
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11></v-flex>
    </v-layout>
    <v-layout row>
      <v-flex md10 lg10 xs12 sm11>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12 v-if="typeEstrategico == '1' ">
          <v-layout>
            <v-flex md8 lg8 xs12 sm12>
              <h4 class="pull">AVANCE TOTAL PLAN DE MEJORAMIENTO INSTITUCIONAL - PROCESO 2014</h4>
            </v-flex>
            <v-flex m4 lg4 xs12 sm12>
              <v-btn   color="#394049"  :to="{name:'documentosArea', params: { id: 15 }}">Información en detalle
                
              </v-btn>
            </v-flex>
          </v-layout>
          <br />
          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <table class="table table-striped header-fixed">
                <thead class="cabecera">
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.size"
                      v-for="(header,index) in headers2"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.border"
                      v-for="(header,index) in headers"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in data1" :key="index">
                    <td style="text-align:left " :class="headers[0].size">{{item.nombre}}</td>
                    <td style="text-align:center " :class="headers[1].size">{{item.acciones}}</td>
                    <td style="text-align:center " :class="headers[2].size">{{item.cumplidas}}</td>
                    <td style="text-align:center " :class="headers[3].size">{{item.avance}}</td>
                  </tr>
                   <tr style="background-color: #5cabd8">
                    <td style="text-align:left " :class="headers[0].size"></td>
                    <td style="text-align:center " :class="headers[1].size"></td>
                    <td style="text-align:center " :class="headers[2].size">Total Avance: </td>
                    <td style="text-align:center " :class="headers[3].size">82%</td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <table class="table table-striped header-fixed">
                <thead class="cabecera">
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.size"
                      v-for="(header,index) in headers4"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.border"
                      v-for="(header,index) in headers3"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item,index) in data2" :key="index">
                    <td style="text-align:left " :class="headers[0].size">{{item.nombre}}</td>
                    <td style="text-align:center " :class="headers[1].size">{{item.acciones}}</td>
                    <td style="text-align:center " :class="headers[2].size">{{item.cumplidas}}</td>
                    <td style="text-align:center " :class="headers[3].size">{{item.avance}}</td>
                  </tr>
                     <tr style="background-color: #5cabd8">
                    <td style="text-align:left " :class="headers[0].size"></td>
                    <td style="text-align:center " :class="headers[1].size"></td>
                    <td style="text-align:center " :class="headers[2].size">Total Avance: </td>
                    <td style="text-align:center " :class="headers[3].size">93%</td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>

          <v-layout>
            <v-flex md12 lg12 xs12 sm12>
              <table class="table table-striped header-fixed">
                <thead class="cabecera">
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.size"
                      v-for="(header,index) in headers6"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                  <tr>
                    <th
                      style="text-align: center"
                      :class="header.border"
                      v-for="(header,index) in headers5"
                      :key="index"
                    >{{header.text}}</th>
                  </tr>
                  
                </thead>
                <tbody>
                  <tr v-for="(item,index) in data3" :key="index">
                    <td style="text-align:left " :class="headers5[0].size">{{item.nombre}}</td>
                    <td style="text-align:center " :class="headers5[1].size">{{item.acciones}}</td>
                    <td style="text-align:center " :class="headers5[2].size">{{item.cumplidas}}</td>
                  </tr>
                     <tr style="background-color: #5cabd8">
                    <td style="text-align:left " :class="headers5[0].size"></td>
                    <td style="text-align:center " :class="headers5[1].size">Total: </td>
                    <td style="text-align:center " :class="headers5[2].size">76%</td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
export default {
  data() {
    return {
      area: "",

      data1: [
        {
          nombre: "Gestión ",
          acciones: "15",
          cumplidas: "14",
          avance: "93%"
        },
        {
          nombre: "Pregrado ",
          acciones: "12",
          cumplidas: "8",
          avance: "67%"
        },

        {
          nombre: "Postgrado ",
          acciones: "11",
          cumplidas: "8",
          avance: "73%"
        },
        {
          nombre: "Investigación",
          acciones: "13",
          cumplidas: "13",
          avance: "100%"
        },
        {
          nombre: "VIME",
          acciones: "12",
          cumplidas: "9",
          avance: "75%"
        }
      ],

      data2: [
        {
          nombre: "Gestión ",
          acciones: "16",
          cumplidas: "14,35",
          avance: "90%"
        },
        {
          nombre: "Pregrado ",
          acciones: "7",
          cumplidas: "6,6",
          avance: "94%"
        },

        {
          nombre: "Postgrado ",
          acciones: "12",
          cumplidas: "11",
          avance: "92%"
        },
        {
          nombre: "Investigación",
          acciones: "21",
          cumplidas: "19",
          avance: "90%"
        },
        {
          nombre: "VIME",
          acciones: "12",
          cumplidas: "12",
          avance: "100%"
        }
      ],

      data3: [
        {
          nombre: "Gestión ",
          acciones: "80%",
          cumplidas: "8 de 10"
        },
        {
          nombre: "Pregrado ",
          acciones: "54%",
          cumplidas: "7 de 13"
        },

        {
          nombre: "Postgrado ",
          acciones: "87%",
          cumplidas: "13 de 15"
        },
        {
          nombre: "Investigación",
          acciones: "86%",
          cumplidas: "6 de 7"
        },
        {
          nombre: "VIME",
          acciones: "83%",
          cumplidas: "5 de 6"
        }
      ],

      headers: [
        {
          text: "Área ",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },

        {
          text: "Nro de acciones",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "Cumplidas",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "% Avance",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        }
      ],

      headers3: [
        {
          text: "Área ",
          value: "name",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },

        {
          text: "Nro de indicadores",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "Cumplidas",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        },
        {
          text: "% Avance",
          value: "muy desacuerdo",
          size: "col-md-3 col-lg-3 col-sm-3 col-xs-3",
          border: "col-md-3 col-lg-3 col-sm-3 col-xs-3 th-border"
        }
      ],

      headers5: [
        {
          text: "Área ",
          value: "name",
          size: "col-md-4 col-lg-4 col-sm-4 col-xs-4",
          border: "col-md-4 col-lg-4 col-sm-4 col-xs-4 th-border"
        },

        {
          text: "% PEI",
          value: "muy desacuerdo",
          size: "col-md-4 col-lg-4 col-sm-4 col-xs-4",
          border: "col-md-4 col-lg-4 col-sm-4 col-xs-4 th-border"
        },
        {
          text: "Nro Ámbitos de Acción",
          value: "muy desacuerdo",
          size: "col-md-4 col-lg-4 col-sm-4 col-xs-4",
          border: "col-md-4 col-lg-4 col-sm-4 col-xs-4 th-border"
        }
      ],
      headers2: [
        {
          text: "Avance de acciones al 2020",
          value: "name",
          size: "col-md-12 col-lg-12 col-sm-12 col-xs-12 th-border"
        }
      ],

      headers4: [
        {
          text: "Avance de indicadores al 2020",
          value: "name",
          size: "col-md-12 col-lg-12 col-sm-12 col-xs-12 th-border"
        }
      ],
      headers6: [
        {
          text: "Participación en el PEI 2016-2020",
          value: "name",
          size: "col-md-12 col-lg-12 col-sm-12 col-xs-12 th-border"
        }
      ],

      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      },

      indicadores: [],
      right: null
    };
  },

  watch: {
    // cuando 'question' cambie, se ejecutará esta función
    "$route.fullPath": function() {
      //console.log("whatcher a detectado un cambio en user");
      this.initComponent();
    }
  },

  created() {
    //console.log("aqui va el nombreeee");
  },
  methods: {}
};
</script>


<style scoped>
.image {
  cursor: pointer;
}
.text-mision {
  color: rgb(255, 255, 255);
  font-size: 11px;
}

.titlep {
  color: #ec6a12;
  font-size: 12px;
}

.table2 {
  height: 100px !important;
}

.cabecera {
  background-color: #4376a2 !important;
  color: white !important;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 230px !important;
  overflow-y: auto;
}

.v-card {
  height: auto !important;
  overflow-y: auto;
}

.td-color {
  background: #394049;
  height: 100%;
}

.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}

.drawner {
  width: 200px !important;
  height: 300px !important;
  margin-left: 15px !important;
  margin-top: 80px !important;
  text-decoration: none !important;
  background-color: #f1f1f1 !important;
  border-left: 1px solid black !important;
}

.drawner2 {
  width: 100% !important;
  height: 250px !important;

  text-decoration: none !important;
  background-color: #394049 !important;
}

.font {
  color: white !important;
}

.containerStyle2 {
  width: 100% !important;
  margin-top: 10px !important;
}
.video {
  width: 100% !important;
  margin-top: 10px !important;
  height: 400px;
}

.containerStyle1 {
  width: 100%;
  margin-top: 25%;
  margin-bottom: 50px;
}

.pull-left {
  text-align: justify;
  padding: 5% !important;
}

.pull {
  text-align: justify;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

.header-fixed {
  width: 100%;
}
.header-fixed > thead,
.header-fixed > tbody,
.header-fixed > thead > tr,
.header-fixed > tbody > tr,
.header-fixed > thead > tr > th,
.header-fixed > tbody > tr > td {
  display: block;
}
.header-fixed > tbody > tr:after,
.header-fixed > thead > tr:after {
  content: " ";
  display: block;
  visibility: hidden;
  clear: both;
}
.header-fixed > tbody {
  overflow-y: auto;
  height: 220px;
  width: 100%;
}

.header-fixed > tbody > tr > td,
.header-fixed > thead > tr > th {
  float: left;
  font-size: 13px;
  border-bottom: 0 !important;
}

.th-border {
  border: #ddd 1px solid !important;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

#myVideo {
  width: 100%;
  height: auto;
}
</style>


// WEBPACK FOOTER //
// src/components/dca/indicadores/Indicador2014.vue